import React, { useMemo } from "react";

/**
 * DatePickerInput
 * ---------------
 * A calendar/date picker that always returns an ISO-like string "yyyy-mm-dd".
 * - Native <input type="date"> by default (no deps).
 * - Enforces min="1900-01-01" and max=<today>.
 *
 * Props:
 * • value      – string "yyyy-mm-dd" or ""
 * • onChange   – (syntheticEventLike) => void   (matches normal <input/> handlers)
 * • id         – string (field id / name)
 * • required   – boolean
 * • className  – optional wrapper classes
 */
export default function DatePickerInput({
  value = "",
  onChange,
  id,
  required,
  className = "",
}) {
  const todayStr = useMemo(() => {
    const d = new Date();
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  }, []);

  const MIN = "1900-01-01";

  const handleChange = (e) => {
    // Native <input type="date"> gives "yyyy-mm-dd" or "".
    const next = e.target.value;

    // Re-emit in the same event shape your form expects:
    onChange({
      target: { name: id, value: next },
    });
  };

  return (
    <div className={className}>
      <input
        id={id}
        name={id}
        type="date"
        className="custom-input w-full"
        value={value || ""}
        onChange={handleChange}
        min={MIN}
        max={todayStr} // no future dates
        required={required}
      />
    </div>
  );
}
